export const GET_PIKS = 'payment-in-kinds/GET_PIKS'
export const ADD_PIK = 'payment-in-kinds/ADD_PIK'
export const APPROVE_PIK = 'payment-in-kind/APPROVE_PIK'
export const REJECT_PIK = 'payment-in-kind/REJECT_PIK'
export const SUBMIT_PIK = 'payment-in-kind/SUBMIT_PIK'
export const DELETE_PIK = 'payment-in-kind/DELETE_PIK'
export const EDIT_PIK = 'payment-in-kind/EDIT_PIK'
export const START_LOADING_PIK = 'payment-in-kind/START_LOADING_PIK'
export const STOP_LOADING_PIK = 'payment-in-kind/STOP_LOADING_PIK'
